/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Kpi_Total_ValueInputs */

const vi_warehouse_sales_kpi_total_value = /** @type {(inputs: Warehouse_Sales_Kpi_Total_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá trị tồn kho`)
};

/**

* @param {Warehouse_Sales_Kpi_Total_ValueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_kpi_total_value = /** @type {((inputs?: Warehouse_Sales_Kpi_Total_ValueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Kpi_Total_ValueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_kpi_total_value(inputs)
});